@if (workspace && share) {
  <div data-m-target="Add new user modal">
    @if (!ppEdit) {
      <pp-share-edit-email-input
        [(ppEmailList)]="ppEmails"
        (ppEmailListChange)="updateEmails($event)"
        [ppWorkspace]="workspace"
        (ppUpdate)="updateShare()"
        class="shareModalHeader--top"
      ></pp-share-edit-email-input>
    }
    @if (ppEdit) {
      <div class="shareEdit__user">
        <span class="sw-icon sw-icon-name"></span>
        <span
          ppTooltip
          [ppTrimTooltip]="true"
          [ppTitle]="
            share.userId && users[share.userId].userName
              ? users[share.userId].userName
              : share.userId
                ? users[share.userId].email
                : share.userEmail
          "
          class="sw-icon-text userEmailText"
        >
          {{
            share.userId && users[share.userId].userName
              ? users[share.userId].userName
              : share.userId
                ? users[share.userId].email
                : share.userEmail
          }}
        </span>
      </div>
    }
    <h6 class="shareModalHeader">
      {{ 'access_level' | ppTranslate }}
    </h6>
    <div class="shareModal__radio-row">
      @for (access of shareOptions; track access) {
        <pp-radio
          [data-m-target]="'Access level ' + access.label + ' button'"
          ppStyle="blue"
          [ppChecked]="access.value === share.shareOption"
          (ppOnValueChange)="onUserTypeSwitched(access)"
        >
          <label class="control-custom control-custom--radio">
            {{ access.label }}
          </label>
        </pp-radio>
      }
    </div>
    <p [class.share__admin-description]="share?.shareOption === EUserRole.SITE_ADMIN">
      @if (share?.shareOption === EUserRole.SITE_ADMIN) {
        {{ 'share_admin_description' | ppTranslate }}
      }
      @if (share?.shareOption === EUserRole.NORMAL) {
        {{ 'share_normal_description' | ppTranslate }}
      }
      @if (share?.shareOption === EUserRole.LIMITED) {
        {{ 'share_guest_description' | ppTranslate }}
      }
    </p>
    @if (share.shareOption !== EUserRole.SITE_ADMIN) {
      <pp-share-edit-tags
        [(ppShare)]="share"
        [ppWorkspaceId]="workspaceId"
        (ppChange)="updateShare()"
        [ppTagError]="ppTagError"
      ></pp-share-edit-tags>
    }
    <div class="shareButton__container">
      @if ((!share || share?.shareOption !== EUserRole.SITE_ADMIN) && !ppShowAdvanced) {
        <pp-button
          data-m-target="Advanced access level button"
          ppId="toggleAdvancedUserModalBtn"
          ppStyle="text"
          class="toggleAdvancedButton"
          (ppAction)="toggleAdvanced()"
        >
          <span class="advancedAccess__text">
            {{ 'advanced' | ppTranslate }}
            <i
              class="fa fa-caret-down settingsTable__icon icon-gap--right2x"
              aria-hidden="true"
            ></i>
          </span>
        </pp-button>
      }
    </div>
    @if (ppShowAdvanced && share.shareOption !== EUserRole.SITE_ADMIN) {
      <pp-share-edit-activity
        [(ppShare)]="share"
        [ppWorkspaceId]="workspaceId"
        (ppChange)="updateShare()"
      ></pp-share-edit-activity>
      <pp-share-edit-site-plan
        [(ppShare)]="share"
        [ppWorkspaceId]="workspaceId"
        (ppChange)="updateShare()"
      ></pp-share-edit-site-plan>
      <pp-share-edit-export
        [(ppShare)]="share"
        [ppWorkspaceId]="workspaceId"
        (ppChange)="updateShare()"
      ></pp-share-edit-export>

      <pp-share-edit-flag
        [ppDisabled]="share.shareOption === EUserRole.LIMITED"
        [(ppShare)]="share"
        [ppWorkspaceId]="workspaceId"
        (ppChange)="updateShare()"
      ></pp-share-edit-flag>

      @if (pointRelationshipsAccessEnabled) {
        <pp-share-edit-relationships
          [ppDisabled]="share.shareOption === EUserRole.LIMITED"
          [(ppShare)]="share"
          [ppWorkspaceId]="workspaceId"
          (ppChange)="updateShare()"
        ></pp-share-edit-relationships>
      }
      <pp-share-edit-comments
        [(ppShare)]="share"
        [ppWorkspaceId]="workspaceId"
        (ppChange)="updateShare()"
      ></pp-share-edit-comments>
      <pp-share-edit-advanced-access
        [(ppShare)]="share"
        [ppWorkspaceId]="workspaceId"
        (ppChange)="updateShare()"
      ></pp-share-edit-advanced-access>
    }
  </div>
}
